export const TOKEN = (env: string): string => `token_${env}`;
export const REFRESH_TOKEN = (env: string): string => `refreshToken_${env}`;
export const WHITE_COLOR = '#ffffff';
export const FALLBACK_800 = `assets/images/avif/fallback_800.avif`;
export const FALLBACK_500 = `assets/images/avif/fallback_500.avif`;
export const FALLBACK_300 = `assets/images/avif/fallback_300.avif`;
export const FALLBACK_100 = `assets/images/avif/fallback_100.avif`;
export const DEBOUNCE_TIME = 300;
export const EMPTY_DEBOUNCE_TIME = 0;
export const DEFAULT_LIST_ITEMS_COUNT = 15;
export const DEFAULT_FOV_VALUE = 55;
export const MAX_NO_LIMIT_VALUE = 100000;
export const URL_3D_SOURCE_ABOUT_US = 'https://3dsource.com/about-us/';
export const URL_3D_SOURCE_SERVICES = 'https://3dsource.com/services/';
export const URL_METABOX_ASSET_PREPARATION_GUIDE =
  'https://3d-source.gitbook.io/3d-source/nwrk7jqZCxLFMRJf3rNQ';
export const SENTRY_DSN_KEY =
  'https://509706c8062a231213c6d88942c683b2@o4507340558565376.ingest.us.sentry.io/4508653736689664';
export const ICONS_FOLDER_PATH = 'assets/images/svg/asset-type-icons/';
export const CHUNK_LOAD_ERRORS = [
  'Failed to fetch dynamically imported module:',
  'error loading dynamically imported module:',
  'Failed to load module script',
  'Importing a module script failed',
];
export const DEFAULT_RENDER_SPINNER_TIMEOUT = 20 * 60;
export const NOT_FOUND = 'Invalid UUID!';
export const NOT_FOUND_PRODUCT =
  'Product was deleted. Please choose another product or upload a new one.';
export const NOT_FOUND_ENVIRONMENT =
  'Environment was deleted. Please choose another environment or upload a new one.';
export const NOT_FOUND_RENDER =
  'Render was deleted. Please choose another render or create a new one.';
export const NOT_FOUND_BASIC_CONFIGURATOR =
  'Basic configurator was deleted. Please choose another configurator or create a new one.';
export const NOT_FOUND_MODULAR_CONFIGURATOR =
  'Modular configurator was deleted. Please choose another configurator or create a new one.';
